import { useContext, useState } from 'react';
import { Grid, Autocomplete, TextField, Tooltip, Button, Menu, MenuItem } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ArrowDropDown } from '@mui/icons-material';
import { CartsContext } from './_CartsContext';
import SimpleAutocompleteProps from '../../../../../reusable-components/autocomplete/SimpleAutocompleteProps';
import DropdownAction from '../../../../../reusable-components/dropdown-action/DropdownAction';

export default function CartCheckoutToolbar() {
  const {
    personFor,
    setPersonFor,
    personForOptions,
    requestedDate,
    setRequestedDate,
    facilityId,
    checkoutCartCategory,
  } = useContext(CartsContext);
  const [anchorElDwnld, setAnchorElDwnld] = useState(null);

  return (
    <Grid container direction="row" justifyContent="flex-start" mt={-0.3} spacing={1} alignItems="center">
      <Grid item>
        <Button
          size="small"
          color="secondary"
          onClick={(e) => setAnchorElDwnld(e.currentTarget)}
          variant="outlined"
          endIcon={<ArrowDropDown />}
        >
          Download
        </Button>
      </Grid>

      <Menu
        anchorEl={anchorElDwnld}
        open={Boolean(anchorElDwnld)}
        onClose={() => setAnchorElDwnld(null)}
        slotProps={{
          paper: {
            sx: {
              width: 207,
              p: 1,
              borderRadius: '5px',
              boxShadow: '0px 2px 6px rgba(0,0,0,.06), 0px 8px 24px rgba(0,0,0,.12)',
            },
          },
          list: {
            sx: {
              display: 'flex',
              flexDirection: 'column',
              gap: '14px',
              p: 0,
            },
          },
        }}
      >
        <MenuItem
          disableRipple
          disableGutters
          sx={{ p: 0, minHeight: 'unset' }}
          onClick={() => {
            setAnchorElDwnld(null);
            window.open(
              `Api/DownloadCart?facilityId=${facilityId}${
                checkoutCartCategory?.categoryId > 0 ? `&categoryId=${checkoutCartCategory?.categoryId}` : ''
              }`,
              '_blank'
            );
          }}
        >
          <DropdownAction badgeIcon="material-symbols:download">Download Cart Excel</DropdownAction>
        </MenuItem>

        <MenuItem
          disableRipple
          disableGutters
          sx={{ p: 0, minHeight: 'unset' }}
          onClick={() => {
            setAnchorElDwnld(null);
            window.open(
              `Api/DownloadCartPDF?facilityId=${facilityId}${
                checkoutCartCategory?.categoryId > 0 ? `&categoryId=${checkoutCartCategory?.categoryId}` : ''
              }`,
              '_blank'
            );
          }}
        >
          <DropdownAction badgeIcon="material-symbols:download">Download Cart PDF</DropdownAction>
        </MenuItem>
      </Menu>
      <Grid item sx={{ flex: 1, maxWidth: 350 }}>
        <Autocomplete
          {...SimpleAutocompleteProps}
          sx={{ width: '100%' }}
          freeSolo
          options={personForOptions}
          forcePopupIcon
          onChange={(event, newValue) => {
            setPersonFor((typeof newValue === 'string' ? newValue : newValue?.name) ?? '');
          }}
          onInputChange={(event, newInputValue, reason) => {
            if (reason === 'input') setPersonFor(newInputValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={personForOptions.find((option) => option.name === personFor)?.label || 'The person for'}
              variant="outlined"
              inputProps={{ ...params.inputProps }}
              autoComplete="off"
            />
          )}
        />
      </Grid>
      <Tooltip title="This is ship date request. Not delivery date request" placement="top" arrow>
        <Grid item>
          <DatePicker
            label="Requested ship date"
            clearable
            value={requestedDate}
            onChange={setRequestedDate}
            slotProps={{ field: { clearable: true }, textField: { size: 'small' } }}
          />
        </Grid>
      </Tooltip>
    </Grid>
  );
}
